/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
import { RecommendedShipmentFragmentDoc } from '../../../shipment/ShipmentCard/graphql/RecommendedShipmentFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IRecommendedShipmentsQueryVariables = Types.Exact<{
  first?: Types.Maybe<Types.Scalars['Int']>
  after?: Types.Maybe<Types.Scalars['String']>
}>

export type IRecommendedShipmentsQuery = { __typename?: 'Query' } & {
  shipmentRecommendations: { __typename?: 'RecommendedShipments' } & Pick<
    Types.IRecommendedShipments,
    'source'
  > & {
      shipments: { __typename?: 'AuctionShipmentConnection' } & {
        nodes?: Types.Maybe<
          Array<
            Types.Maybe<
              { __typename?: 'AuctionShipment' } & Pick<
                Types.IAuctionShipment,
                | 'deliveryCity'
                | 'deliveryStateCode'
                | 'deliveryTimes'
                | 'deliveryTimezone'
                | 'distance'
                | 'equipmentName'
                | 'equipmentParentId'
                | 'pickupCity'
                | 'pickupStateCode'
                | 'pickupTimes'
                | 'pickupTimezone'
                | 'rate'
                | 'shipmentId'
                | 'unviewed'
                | 'weight'
              >
            >
          >
        >
        pageInfo: { __typename?: 'PageInfo' } & Pick<
          Types.IPageInfo,
          'hasNextPage' | 'startCursor' | 'endCursor'
        >
      }
    }
}

export const RecommendedShipmentsDocument = gql`
  query RecommendedShipments($first: Int, $after: String) {
    shipmentRecommendations {
      source
      shipments(first: $first, after: $after) {
        nodes {
          ...RecommendedShipment
        }
        pageInfo {
          hasNextPage
          startCursor
          endCursor
        }
      }
    }
  }
  ${RecommendedShipmentFragmentDoc}
`

/**
 * __useRecommendedShipmentsQuery__
 *
 * To run a query within a React component, call `useRecommendedShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedShipmentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRecommendedShipmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IRecommendedShipmentsQuery,
    IRecommendedShipmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IRecommendedShipmentsQuery, IRecommendedShipmentsQueryVariables>(
    RecommendedShipmentsDocument,
    options
  )
}
export function useRecommendedShipmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IRecommendedShipmentsQuery,
    IRecommendedShipmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IRecommendedShipmentsQuery, IRecommendedShipmentsQueryVariables>(
    RecommendedShipmentsDocument,
    options
  )
}
export type RecommendedShipmentsQueryHookResult = ReturnType<typeof useRecommendedShipmentsQuery>
export type RecommendedShipmentsLazyQueryHookResult = ReturnType<
  typeof useRecommendedShipmentsLazyQuery
>
export type RecommendedShipmentsQueryResult = Apollo.QueryResult<
  IRecommendedShipmentsQuery,
  IRecommendedShipmentsQueryVariables
>
